import { Component, OnInit } from '@angular/core';
import '../../../../assets/amazon-connect-chat-interface.js';

declare var connect: any;

@Component({
  selector: 'app-chat-test',
  templateUrl: './chat-test.component.html',
  styleUrls: ['./chat-test.component.css']
})
export class ChatTestComponent {
  closeChatDelay = 2000;
  displayClass = "hidden-chat";
  customerName = "peter";
  email = "pparker@dbugle.net";
  policyNumber = "";
  quoteNumber = "";
  contactFlowId = "d8194a22-73fc-4d1d-85be-fc159d316b11";
  instanceId = "af9d927d-2cc6-45ca-976b-3c63cba3eb2c";
  apiGatewayEndpoint = "https://eccchatt0.npdcnct.aws.kemperi.com/chat";
  autoMessageEnabled = true;
  triggerText: "Please wait...";
  responseText: "Connecting...";
  showHelp = false;
  appName = "KAAP";
  applicationOptions = ['KAAP', 'CVAS', 'BUI'];
  notificationPathLocal = 'assets/notification.wav';
  
  identities = [
    {
      email: "pparker@dbugle.net",
      name: "Peter"
    },
    {
      email: "odunham@fbi.gov",
      name: "Olivia"
    },
    {
      email: "dschrute@dundermifflin.net",
      name: "Dwight"
    },
    {
      email: "swilkins@gda.gov",
      name: "Samantha"
    }
  ]

  ngOnInit(){
    console.log(connect);
    console.log(connect.ChatInterface.init);
    this.initializeConfig('dev');
    localStorage.setItem('notificationPathLocal', this.notificationPathLocal);
    const notificationWavFile = localStorage.getItem('notificationPathLocal')
  }
  // playSound() {
  //   const notificationWavFile = localStorage.getItem('notificationPathLocal')
  //     const audio = new Audio(notificationWavFile);
  //     audio.play();
  //   };
  initializeConfig(env){
    if(env == 'dev'){
      // this.playSound();
      this.contactFlowId = "a8274eef-5727-4951-8816-9c871896d8a1";
      this.instanceId = "9776af2e-1653-4d58-b428-710b939cc959";
      this.apiGatewayEndpoint = "https://eccchatd0.npdcnct.aws.kemperi.com/chat";
    }else if(env == 'test'){
      this.contactFlowId = "d8194a22-73fc-4d1d-85be-fc159d316b11";
      this.instanceId = "af9d927d-2cc6-45ca-976b-3c63cba3eb2c";
      this.apiGatewayEndpoint = "https://eccchatt0.npdcnct.aws.kemperi.com/chat";
    }else if(env == 'uat'){
      this.contactFlowId = "f61e288a-bace-4f94-baf9-c16906577872";
      this.instanceId = "cee909a6-6589-4d79-8f7b-ed6c9d2dd3eb";
      this.apiGatewayEndpoint = "https://eccchatu0.npdcnct.aws.kemperi.com/chat";
    }

    var identity = this.identities[Math.floor(Math.random()*this.identities.length)];

    this.email = identity.email;
    this.customerName = identity.name;
    this.autoMessageEnabled = true;
    this.triggerText = "Please wait...";
    this.responseText = "Connecting...";
    this.appName = "KAAP";
    this.quoteNumber = "";
    this.policyNumber = "";
  }

  launch() {
    connect.ChatInterface.init({
      containerId: 'root'
    });

    const attr = {
      "customerName": this.customerName,
      "policyNumber": this.policyNumber,
      "quoteNumber": this.quoteNumber,
      "producerCode": "",
      "agencyEamil": this.email,
      "agentPhone": "",
      "agentId": "someIdHere",
      "appName": this.appName
    }

    var input = {
      name: this.customerName,
      region: "us-east-1", // TODO: fill in
      apiGatewayEndpoint: this.apiGatewayEndpoint,
      username: this.email,
      contactAttributes: JSON.stringify(attr),
      contactFlowId: this.contactFlowId,
      instanceId: this.instanceId,
      autoMessage: {
        trigger: this.triggerText,
        response: this.responseText,
        enabled: this.autoMessageEnabled
      }
    }
    console.log("Input: ", input);
    console.log("Attributes: ", attr);
    connect.ChatInterface.initiateChat(input, this.successHandler.bind(this), this.failureHandler.bind(this));
  }

  successHandler(chatSession) {
    console.log("success!");
    this.displayClass = "revealed-chat"

    chatSession.onChatDisconnected(function(data) {
      setTimeout(()=>{
        this.displayClass = "hidden-chat";
      }, this.closeChatDelay)
      
    }.bind(this));
  }

  failureHandler(error) {
    console.log("There was an error: ", error);
  }
}